/*!
 * devextreme-vue
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

import { defineComponent } from 'vue';
import { initDxComponent } from '../../component';
import { initDxConfiguration } from '../../configuration-component';
import { initDxExtensionComponent } from '../../extension-component';
import { setCompatOptions, setVModel } from '../../vue-helper';
export function createComponent(config) {
    config.extends = initDxComponent();
    setCompatOptions(config);
    if (config.model) {
        setVModel(config);
    }
    return defineComponent(config);
}
export function createConfigurationComponent(config) {
    config.extends = initDxConfiguration();
    setCompatOptions(config);
    return defineComponent(config);
}
export function createExtensionComponent(config) {
    config.extends = initDxExtensionComponent();
    setCompatOptions(config);
    return defineComponent(config);
}
